import { useEffect, useState } from "react";
import { getClientId } from "../../shared/flavours/useFlavour";

import { handleGtmInit } from "./GTM";
import { TrackingParams } from "./consts";
import "@/i18n";
import { storageAvailable } from "@/api/localStorage";

const client_id = getClientId();

/* GTM */
const userCookieConsents =
  storageAvailable() && localStorage.getItem("userCookieConsents")
    ? { ...JSON.parse(localStorage.getItem("userCookieConsents") || "{}") }
    : "";

// const cookieConsentBannerStatus = localStorage.getItem("cookieConsentBanner") || "";
const userHasAcceptedTrackingCookies = userCookieConsents?.functional || userCookieConsents?.marketing ? true : false;
// const userHasSubmittedConsentsBefore = userCookieConsents && cookieConsentBannerStatus ? true : false;

const urlParams = new URLSearchParams(window.location.search);
const isTrackingEnabled = urlParams.get("noscript") !== "true";

const addHours = (date: Date, hours: number) => {
  return new Date(date.getTime() + hours * 60 * 60 * 1000);
};

export const useTracking = (initials?: Record<string, string>) => {
  const [state, dispatch] = useState<Record<string, string | Record<string, string>>>({ queryParams: "", rmdTrx: {} });

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const queryParams = Object.fromEntries(urlSearchParams.entries());
    const rmdTrx = {
      rmd_trx_source: queryParams["rmd_trx_source"],
      rmd_trx_content: queryParams["rmd_trx_content"],
      rmd_trx_campaign: queryParams["rmd_trx_campaign"],
      rmd_trx_medium: queryParams["rmd_trx_medium"],
      rmd_trx_term: queryParams["rmd_trx_term"],
    };

    const generalTracking: Record<string, string> = {};
    for (const [key, val] of Object.entries(queryParams)) {
      for (let i = 0; i < TrackingParams.length; i++) {
        if (TrackingParams[i].allowed.includes(key)) {
          generalTracking[TrackingParams[i].payload] = val;
          break;
        }
      }
    }

    const localStorageTracking = {
      ...generalTracking,
      ...(initials && typeof initials === "object" && { ...initials }),
    };

    // Remove expired local storage items.
    const allItems = { ...localStorage };
    for (const [key] of Object.entries(allItems)) {
      const item = localStorage.getItem(key);
      let parsedItem;
      try {
        if (item) {
          parsedItem = JSON.parse(item);
        }
      } catch (e) {}
      if (parsedItem?.expiry) {
        const expiryDate = new Date(parsedItem.expiry);
        const today = new Date();
        if (today > expiryDate) {
          localStorage.removeItem(key);
        }
      }
    }

    const isTopDeals = window.location.href.includes("top-deals");

    // Set new tracking values in local storage, but don't overwrite when already existing.
    for (const [key, value] of Object.entries(localStorageTracking)) {
      if (!localStorage.getItem(key) || isTopDeals) {
        let expiryDate = new Date();
        expiryDate = addHours(expiryDate, 48);
        const item = { value, expiry: expiryDate.toISOString() };
        localStorage.setItem(key, JSON.stringify(item));
      }
    }

    if (!!urlSearchParams.toString() && !localStorage.getItem("queryParams")) {
      let expiryDate = new Date();
      expiryDate = addHours(expiryDate, 48);
      const item = { value: urlSearchParams.toString(), expiry: expiryDate.toISOString() };
      localStorage.setItem("queryParams", JSON.stringify(item));
    }

    const payload: Record<string, string | Record<string, string>> = { rmdTrx };

    // Add queryParams to all items which should be checked in local storage. queryParams cannot be part of initial TrackingParams object, so we have to handle it like that.
    const iterations = [...structuredClone(TrackingParams), { allowed: ["queryParams"], payload: "queryParams" }];

    // Re-add tracking items from local storage to state to make it accessible from outside.
    const currentLocalStorage = { ...localStorage };
    for (const [key, val] of Object.entries(currentLocalStorage)) {
      for (let i = 0; i < iterations.length; i++) {
        if (iterations[i].allowed.includes(key)) {
          let parsedVal = val;
          try {
            parsedVal = JSON.parse(val);
          } catch (e) {}
          payload[iterations[i].payload] = typeof parsedVal === "string" ? parsedVal : parsedVal?.value;
          break;
        }
      }
    }

    dispatch(payload);

    if (client_id === "remindmeApp" || (userHasAcceptedTrackingCookies && isTrackingEnabled)) {
      handleGtmInit();
    }
    // eslint-disable-next-line
  }, []);

  return state;
};
